var React = require('react');

function MenuChartIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M10.357 11c-.59 0-1.071-.48-1.071-1.071s.48-1.072 1.071-1.072c.59 0 1.072.48 1.072 1.072 0 .59-.481 1.071-1.072 1.071zM5 2.429h6.429V2H5v.429zM2.643 11c-.59 0-1.072-.48-1.072-1.071s.481-1.072 1.072-1.072c.59 0 1.071.48 1.071 1.072 0 .59-.48 1.071-1.071 1.071zM12.076.714H4.522c-.352 0-.638.294-.638.656v6.207c-.345-.193-.74-.303-1.161-.303C1.379 7.274.286 8.398.286 9.78c0 1.382 1.093 2.506 2.437 2.506 1.344 0 2.437-1.124 2.437-2.506V4.024h6.278v3.553c-.345-.193-.74-.303-1.161-.303-1.344 0-2.437 1.124-2.437 2.506 0 1.382 1.093 2.506 2.437 2.506 1.344 0 2.437-1.124 2.437-2.506V1.37c0-.362-.285-.656-.638-.656z"}));
}

MenuChartIcon.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13"};

module.exports = MenuChartIcon;

MenuChartIcon.default = MenuChartIcon;
